import React, { useEffect, useState } from "react";
import { useHistory, withRouter } from "react-router-dom";
import { useTranslation, withTranslation } from "react-i18next";
import "../../css/Navbar.css";
import { MenuUsaDesk } from "./menuUsaDesk";
import { MenuUsaMobile } from "./menuUsaMobile";
import { useContext } from "react";
import { ActualLangContext } from "../../contexts/ActualLangContext";
import { ContentLayoutContext } from "../../contexts/ContentLayoutContext";

const MenuUsa = () => {
  const history = useHistory();
  const [checked, setchecked] = useState(false);
  const { i18n } = useTranslation();

  const { actualLang } = useContext(ActualLangContext);

  const { navbarContent } = useContext(ContentLayoutContext);

  useEffect(() => {
    if (actualLang === "es") {
      i18n.changeLanguage("es");
      localStorage.setItem("lang", "es");
      let newUrl = window.location.pathname.replace(/^\/en\//, "/es/").replace(/^\/en-en\//, "/es-es/");
      history.replace(newUrl);
      setchecked(true);
    } else if (actualLang === "en") {
      i18n.changeLanguage("en");
      localStorage.setItem("lang", "en");
      let newUrl = window.location.pathname.replace(/^\/es\//, "/en/").replace(/^\/es-es\//, "/en-en/");
      history.replace(newUrl);
      setchecked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  function handleChange(event) {
    if (event.target.type === "checkbox") {
      setchecked(!checked);
    }
  }
  return (
    <>
      <MenuUsaDesk
        logo={navbarContent?.logo}
        options={navbarContent?.options}
        buttons={navbarContent?.buttons}
        handleChange={handleChange}
        checked={checked}
      />
      <MenuUsaMobile
        logo={navbarContent?.logo}
        options={navbarContent?.options}
        buttons={navbarContent?.buttons}
        handleChange={handleChange}
        checked={checked}
      />
    </>
  );
};
export const LanguageSwitcher = withRouter(withTranslation("routes")(MenuUsa));
export default MenuUsa;
